import PropTypes from 'prop-types';

import { Button } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import { lengthValidation120, required } from '../../Forms/utils';

import { GUESTS_ROLES } from '../constants';

import { REACT_SELECT_INPUT, STYLED_TEXT } from '../../Forms/fieldTypes';

const AddRsvpFormComponent = ({
  onSubmit,
  initialValues,
  selectOptions,
  radio,
  onLoad,
  form,
  handleClose,
}) => {
  const { t } = useTransl();
  const formData = [
    {
      keyName: 'rsvp',
      label: t('title.rsvp'),
      fieldType: REACT_SELECT_INPUT,
      options: selectOptions,
      validate: [required],
    },
    {
      keyName: 'attendeeName',
      label: t('title.guestName'),
      fieldType: STYLED_TEXT,
      validate: [lengthValidation120, required],
      isHidden: radio !== GUESTS_ROLES.nonresident,
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onLoad={onLoad}
      onSubmit={onSubmit}
      initialValues={initialValues}
      submitText={t('actions.add')}
      backButton={false}
      CustomComponent={() => (
        <Button
          onClick={handleClose}
          variant="contained"
          sx={(theme) => ({ backgroundColor: theme.palette.grey[500] })}
          disableElevation
        >
          {t('actions.cancel')}
        </Button>
      )}
      isFullWidthForm
    />
  );
};

AddRsvpFormComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  selectOptions: PropTypes.instanceOf(Array),
  radio: PropTypes.string.isRequired,
  onLoad: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AddRsvpFormComponent;
